import ClientBaseClass from './ClientBaseClass'
import Location from '../../models/Location'

export default class OwnerAdminApi extends ClientBaseClass {
	handleAccessManagementResponse(response, responseHandler, successStatus = 200) {
		switch (response.status) {
		case successStatus:
			if (responseHandler[`status${successStatus}`]) {
				response.json()
					.then(responseJson => {
						responseHandler[`status${successStatus}`](responseJson)
					})
					.catch(responseHandler.error)
				return true
			}
			break
		case 403:
			if (responseHandler.status403) {
				response.text()
					.then(responseText => {
						responseHandler.status403(responseText)
					})
					.catch(responseHandler.error)
				return true
			}
			break
		case 409:
		case 422:
			if (responseHandler[`status${response.status}`]) {
				response.json()
					.then(responseJson => {
						responseHandler[`status${response.status}`](responseJson)
					})
					.catch(responseHandler.error)
				return true
			}
			break
		}

		return false
	}

	permissions(responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/permissions'

		this.executeApiCall(url, 'get', null, null, options)
			.then(response => {
				switch (response.status) {
				case 200:
					if (responseHandler.status200) {
						response.json()
							.then(responseJson => {
								responseHandler.status200(responseJson)
							})
							.catch(responseHandler.error)
						return
					}
					break
				}

				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	accessManagement(responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/access-management'

		this.executeApiCall(url, 'get', null, null, options)
			.then(response => {
				if (this.handleAccessManagementResponse(response, responseHandler, 200)) return
				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	addOwnerAccess(request, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/access-management/owners'

		this.executeApiCall(url, 'post', request, 'json', options)
			.then(response => {
				if (this.handleAccessManagementResponse(response, responseHandler, 201)) return
				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	removeOwnerAccess(email, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = `/owner-admin/access-management/owners/${encodeURIComponent(email)}`

		this.executeApiCall(url, 'delete', null, null, options)
			.then(response => {
				if (this.handleAccessManagementResponse(response, responseHandler, 200)) return
				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	addAdminAccess(request, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/access-management/admins'

		this.executeApiCall(url, 'post', request, 'json', options)
			.then(response => {
				if (this.handleAccessManagementResponse(response, responseHandler, 201)) return
				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	removeAdminAccess(email, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = `/owner-admin/access-management/admins/${encodeURIComponent(email)}`

		this.executeApiCall(url, 'delete', null, null, options)
			.then(response => {
				if (this.handleAccessManagementResponse(response, responseHandler, 200)) return
				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	listLocations(responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/locations'

		this.executeApiCall(url, 'get', null, null, options)
			.then(response => {
				switch (response.status) {
				case 200:
					if (responseHandler.status200) {
						response.json()
							.then(responseJson => {
								responseHandler.status200(Location.createArray(responseJson))
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 403:
					if (responseHandler.status403) {
						response.text()
							.then(responseText => {
								responseHandler.status403(responseText)
							})
							.catch(responseHandler.error)
						return
					}
					break
				}

				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	listLocationEmailAudit(filters, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const searchParams = new URLSearchParams()

		Object.entries(filters || {}).forEach(([key, value]) => {
			if (value !== null && value !== undefined && value !== '') {
				searchParams.set(key, value)
			}
		})

		const queryString = searchParams.toString()
		const url = `/owner-admin/location-created-notifications${queryString ? `?${queryString}` : ''}`

		this.executeApiCall(url, 'get', null, null, options)
			.then(response => {
				switch (response.status) {
				case 200:
					if (responseHandler.status200) {
						response.json()
							.then(responseJson => {
								responseHandler.status200(responseJson)
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 403:
					if (responseHandler.status403) {
						response.text()
							.then(responseText => {
								responseHandler.status403(responseText)
							})
							.catch(responseHandler.error)
						return
					}
					break
				}

				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	createLocation(request, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = '/owner-admin/locations'

		this.executeApiCall(url, 'post', request, 'json', options)
			.then(response => {
				switch (response.status) {
				case 201:
					if (responseHandler.status201) {
						response.json()
							.then(responseJson => {
								responseHandler.status201(Location.create(responseJson))
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 403:
					if (responseHandler.status403) {
						response.text()
							.then(responseText => {
								responseHandler.status403(responseText)
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 422:
					if (responseHandler.status422) {
						response.json()
							.then(responseJson => {
								responseHandler.status422(responseJson)
							})
							.catch(responseHandler.error)
						return
					}
					break
				}

				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}

	updateLocation(id, request, responseHandler, options) {
		responseHandler = this.generateResponseHandler(responseHandler, options)

		const url = `/owner-admin/locations/${id}`

		this.executeApiCall(url, 'put', request, 'json', options)
			.then(response => {
				switch (response.status) {
				case 200:
					if (responseHandler.status200) {
						response.json()
							.then(responseJson => {
								responseHandler.status200(Location.create(responseJson))
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 403:
					if (responseHandler.status403) {
						response.text()
							.then(responseText => {
								responseHandler.status403(responseText)
							})
							.catch(responseHandler.error)
						return
					}
					break
				case 422:
					if (responseHandler.status422) {
						response.json()
							.then(responseJson => {
								responseHandler.status422(responseJson)
							})
							.catch(responseHandler.error)
						return
					}
					break
				}

				this.handleUnhandledResponse(response, responseHandler)
			})
			.catch(error => {
				responseHandler.error(error)
			})
	}
}
